<template>
  <Layout>
    <div class="container-of-future">
      <div class="future-req">
        <q-card square>
          <div class="future-header">Future Value Calculator*</div>
          <div class="future-content">
            <q-form @submit.prevent="onSubmit" ref="form">
              <div class="row q-col-gutter-md">
                <div class="col-md-12 col-xs-12 col-lg-12 col-xl-12">
                  <q-input
                    :disable="saved_locations.length > 0"
                    hide-bottom-space
                    label-color="black"
                    lazy-rules
                    color="black"
                    input-style="color:#000 !important;"
                    :rules="[
                      val => (val !== null && val !== '') || 'Please type month count',
                      val => (val > 0 && val < 100) || 'Month must bigger than 0'
                    ]"
                    outlined
                    type="number"
                    label="Months"
                    v-model="month"
                  ></q-input>
                </div>
                <div class="col-md-12 col-xs-12 col-lg-12 col-xl-12">
                  <q-select
                    label="Select Location*"
                    input-style="color:#000 !important;"
                    v-model="location_id"
                    outlined
                    :disable="locations.length === 0"
                    label-color="black"
                    color="black"
                    :rules="[locationChecker]"
                    :option-label="loc => loc.name"
                    hide-bottom-space
                    :options="locations"
                    lazy-rules
                  >
                    <template v-slot:no-option>
                      <q-item>
                        <q-item-section class="text-italic text-grey">
                          There is no options.
                        </q-item-section>
                      </q-item>
                    </template>
                  </q-select>
                </div>
                <!-- <div class="col-md-12 col-xs-12 col-lg-12 col-xl-12">
                  <q-select
                    label="Select Provider"
                    input-style="color:#000 !important;"
                    v-model="provider"
                    outlined
                    label-color="black"
                    color="black"
                    :options="providers"
                    :option-label="(_provider) => _provider.name"
                    :option-value="(_provider) => _provider.key"
                    hide-bottom-space
                  />
                </div> -->
                <div class="col-md-12 col-xs-12 col-lg-12 col-xl-12">
                  <q-input
                    outlined
                    hide-bottom-space
                    type="number"
                    step="0.1"
                    input-style="color:#000 !important;"
                    color="black"
                    lazy-rules
                    label-color="black"
                    prefix="%"
                    :disable="!location_id || !location_id.id"
                    :rules="[
                      val => (val !== null && val !== '') || 'Please type monthly depreciation assumption',
                      val => (val > 0 && val < 100) || 'Monthly depreciation assumption must bigger than 0'
                    ]"
                    v-model="monthly_depreciation_assumption"
                    label="Monthly Depreciation Assumption*"
                  ></q-input>
                </div>
                <div class="col-md-12 col-xs-12 col-lg-12 col-xl-12">
                  <q-input
                    outlined
                    label-color="black"
                    hide-bottom-space
                    type="number"
                    color="black"
                    input-style="color:#000 !important;"
                    lazy-rules
                    :disable="!location_id || !location_id.id"
                    :rules="[
                      val => (val !== null && val !== '') || 'Please type monthly mileage assumption',
                      val => val > 0 || 'Monthly mileage assumption must bigger than 0'
                    ]"
                    v-model="monthly_mileage_assumption"
                    label="Monthly Mileage Assumption*"
                  ></q-input>
                </div>
                <div class="col-md-12 col-xs-12 col-lg-12 col-xl-12" v-if="saved_locations.length > 0">
                  <q-btn
                    push
                    color="white"
                    text-color="primary"
                    outline
                    v-for="(location, index) in saved_locations"
                    :key="index"
                    @remove="del(index)"
                    :label="location.code ? location.code : location.name"
                    @click="saved_locations.splice(index, 1)"
                    style="margin-right: 5px; margin-bottom: 5px"
                  >
                    <q-badge color="orange" floating transparent align="middle"
                      >{{ location.monthly_depreciation_assumption }}%</q-badge
                    >
                  </q-btn>
                </div>
                <div class="col-12">
                  <div style="margin-bottom: 15px" :class="{ hide: saved_locations.length > 0 }">
                    <q-btn
                      @click="directReq"
                      :disable="loading || !disableForDirect"
                      :loading="loading"
                      color="positive"
                      style="width: 100%"
                      >CALCULATE</q-btn
                    >
                  </div>
                  <div style="justify-content: flex-end; display: flex">
                    <q-btn-group push>
                      <q-btn
                        push
                        icon="far fa-file-excel"
                        dense
                        round
                        color="positive"
                        title="Export Excel"
                        :disable="loading || disableController"
                        @click="exportExcel"
                        :loading="loading"
                      />
                      <q-btn
                        push
                        icon="fas fa-calculator"
                        dense
                        round
                        color="info"
                        :loading="loading"
                        title="Calculate Future Value"
                        @click="getReport"
                        :disable="loading || disableController"
                      />
                      <q-btn
                        push
                        icon="fas fa-times"
                        dense
                        round
                        color="negative"
                        title="Clear"
                        :disable="loading"
                        @click="clear"
                      />
                      <q-btn push icon="fas fa-plus" type="submit" :disable="loading" color="positive" round dense />
                    </q-btn-group>
                  </div>
                </div>
              </div>
            </q-form>
          </div>
        </q-card>
        <div class="calculate-rows" v-if="future.length > 0">
          <div class="black-box col-12">
            <div class="black-box-title">Total Units</div>
            <div class="black-box-value">{{ future.length }}</div>
          </div>
          <div class="black-box col-12">
            <div class="black-box-title">Total Current Auction Value</div>
            <div class="black-box-value">
              {{ summerByKey('current_auction') }}
            </div>
          </div>
          <!-- <div class="black-box col-12">
            <div class="black-box-title">Total Projected Auction Value</div>
            <div class="black-box-value">
              {{ summerByKey("projected_auction") }}
            </div>
          </div> -->
          <div class="black-box col-12">
            <div class="black-box-title">
              Total Owners Depreciation Assumption
            </div>
            <div class="black-box-value">
              {{ summerByKey('owner_depreciation') }}
            </div>
          </div>
          <div class="black-box col-12" id="last-row">
            <div class="black-box-title">Total Projected Payoff</div>
            <div class="black-box-value">
              {{ summerByKey('projected_payoff') }}
            </div>
          </div>
        </div>
      </div>
      <div class="result-of-future">
        <div v-if="future.length > 0" style="background: #fff; margin-bottom: 10px">
          <q-input outlined label="Search via VIN" clearable clear-icon="fas fa-times" v-model="search" dense>
            <template v-slot:prepend>
              <q-icon name="fas fa-search" />
            </template>
          </q-input>
        </div>
        <div ref="tablev2" id="table-scroll" v-if="filteredList.length > 0 && !loading" class="table-scroll">
          <q-btn
            v-if="future.length > 0 && innerShow"
            class="glossy custom-item-icon-4 left-0"
            style="margin-left: -10px"
            @mousedown="shiftLeft()"
            @mouseup="shiftLeftEnd()"
            round
            color="primary"
            icon="fas fa-arrow-left"
          />
          <q-btn
            v-if="future.length > 0 && innerShow"
            class="glossy custom-item-icon-4 right-0"
            @mouseup="shiftRightEnd()"
            @mousedown="shiftRight()"
            round
            color="primary"
            icon="fas fa-arrow-right"
          />
          <table id="main-table" class="main-table" v-if="future.length > 0">
            <draggable v-bind="dragOptions" @start="drag = true" @end="drag = false" v-model="columns" tag="thead">
              <transition-group class="head-tr" tag="tr" type="transition" :name="drag ? 'flip-list' : null">
                <th
                  style="cursor: all-scroll"
                  v-for="col in columns"
                  :key="col.value"
                  @click="sortTable(col.value)"
                  scope="col"
                >
                  <div>
                    {{ col.name }}
                    <i
                      v-if="sort.name && col.value == sort.name"
                      :class="sort.count % 2 == 1 ? 'fas fa-arrow-down' : 'fas fa-arrow-up'"
                      style="font-size: 12px"
                    ></i>
                  </div>
                </th>
              </transition-group>
            </draggable>
            <transition-group name="flip-list" tag="tbody">
              <tr
                class="hoverable-tr"
                v-for="item in filteredList"
                :key="item.id"
                @click="detail(item)"
                style="border-bottom: 1px solid #ccc"
              >
                <td
                  style="min-width: 150px"
                  v-for="header in columns"
                  :key="header.value"
                  :style="
                    item.owner_depreciation_assumption_revenue > 0
                      ? 'background:rgba(76, 175, 80, 0.1)'
                      : 'background:rgba(244, 67, 54, 0.1)'
                  "
                >
                  {{ valueSpawner(typeof item[header.value], item[header.value], header, item) }}
                </td>
              </tr>
            </transition-group>
          </table>
        </div>
        <div class="loading-infinite" v-if="loading">
          <div>
            <q-spinner-facebook color="primary" size="40px" />
            <div class="text-grey-7">Loading</div>
          </div>
        </div>
        <q-card style="padding: 15px" v-if="filteredList.length === 0 && !loading">
          <empty-value description="Feel free to calculate." name="calculate result"></empty-value>
        </q-card>
      </div>
    </div>
    <future-value-id :carDetails="carDetails"></future-value-id>
  </Layout>
</template>

<script>
import Layout from '../components/Layout'
import EmptyValue from '../components/EmptyValue'
import draggable from 'vuedraggable'
import axios from '../axios'
import FutureValueId from '../components/FutureValueId'
import {defaultStatusValues} from "@/enums";

export default {
  metaInfo() {
    return {
      title: `${
        !this.show
          ? 'Showing certain future month’s Projected Market Value and Calculated Pay-off Value by using different assumptions.'
          : 'Showing Vehicle’s Future Market Value and Pay-off Amount trend graphic and values.'
      } | FMS`,
      meta: [
        {
          name: 'description',
          // "FMS is about connecting in your field of interest. Our vision is to help people share their knowledge, work, projects, papers and ideas and build their network through what they do rather where they live, study or work.",
          content:
            'Showing certain future month’s Projected Market Value and Calculated Pay-off Value by using different assumptions.'
        },
        {
          property: 'og:title',
          content: `${
            !this.show
              ? 'Showing certain future month’s Projected Market Value and Calculated Pay-off Value by using different assumptions.'
              : 'Showing Vehicle’s Future Market Value and Pay-off Amount trend graphic and values.'
          } | FMS`
        },
        { property: 'og:site_name', content: 'FMS' },
        { property: 'og:type', content: 'website' },
        { name: 'robots', content: 'index,follow' }
      ]
    }
  },
  data() {
    return {
      innerShow: true,
      rightInterval: null,
      leftInterval: null,
      providers: [
        // { name: "JD Power", key: "jd_power" },
        { name: 'Manheim', key: 'manheim' }
      ],
      provider: { name: 'Manheim', key: 'manheim' },
      search: '',
      sort: {
        name: '',
        count: 0
      },
      drag: false,
      columns: [
        { value: 'index', name: 'Line #' },
        { value: 'vin', name: 'Vin' },
        { value: 'unit', name: 'Unit' },
        { value: 'brand', name: 'Brand' },
        { value: 'model', name: 'Model' },
        { value: 'class_name', name: 'Vehicle Class' },
        { value: 'model_year', name: 'Model Year' },
        { value: 'current_mileage', name: 'Current Mileage' },
        { value: 'current_auction', name: 'Current Auction Value' },
        { value: 'projected_mileage', name: 'Projected Mileage' },
        { value: 'condition', name: 'Condition' },
        { value: 'location', name: 'Location' },
        //{ value: "projected_auction", name: "Projected Auction Value" },
        // {
        //   value: "auction_projected_value_differance",
        //   name: "Auction Projected Value Difference",
        // },
        { value: 'owner_depreciation', name: 'Owner Depreciation Assumption' },
        {
          value: 'owner_depreciation_assumption_revenue',
          name: 'Estimated Rev/Loss based on Owner Depr. Assumption'
        },
        { value: 'projected_payoff', name: 'Projected Payoff' }
        // {
        //   value: "calculated_revenue",
        //   name: "Estimated Rev/Loss Based on Projected Auction Value",
        // },
      ],
      future: [],
      saved_locations: [],
      monthly_depreciation_assumption: null,
      month: 3,
      location_id: null,
      locations: [],
      monthly_mileage_assumption: null,
      carDetails: {}
    }
  },
  components: {
    EmptyValue,
    Layout,
    FutureValueId,
    draggable
  },
  computed: {
    params() {
      return null
      // {provider: this.provider.key};
    },
    filteredList() {
      if (!this.search) return this.future
      else
        return this.future.filter(vehicle => {
          return vehicle.vin.toLowerCase().includes(this.search.toLowerCase())
        })
    },
    disableForDirect() {
      return (
        this.saved_locations.length === 0 &&
        this.month >= 0 &&
        this.month &&
        this.location_id &&
        this.location_id.id &&
        this.monthly_depreciation_assumption &&
        this.monthly_mileage_assumption
      )
    },
    disableController() {
      return this.saved_locations.length === 0
    },
    loading: {
      get() {
        return this.$store.state.future.loading
      },
      set(val) {
        this.$store.commit('future/SET_LOADING', val)
      }
    },
    show: {
      get() {
        return this.$store.state.future.show
      },
      set(val) {
        this.$store.commit('future/SET_SHOW', val)
      }
    },
    valueSpawner() {
      return (type, val, column, row) => {
        if (column.name === 'Line #') return val
        if (column.name === 'Condition') return val ? val.charAt(0).toUpperCase() + val.slice(1) : '-'
        if (type == 'object') return val && val.name ? val.name : '-'
        else {
          if (
            column.name === 'Vin' ||
            column.name === 'Unit' ||
            column.name === 'Brand' ||
            column.name === 'Vehicle Class' ||
            column.name === 'Model Year'
          ) {
            return val || '-'
          } else if (column.name === 'Current Mileage' || column.name === 'Projected Mileage') {
            return val.toLocaleString('en-US')
          } else {
            return val.toLocaleString('en-US', {
              style: 'currency',
              currency: 'USD'
            })
          }
        }
      }
    },
    dragOptions() {
      return {
        animation: 200,
        group: 'description',
        disabled: false,
        ghostClass: 'ghost'
      }
    }
  },
  mounted() {
    this.getLocations()
    document.querySelector('.scroll').addEventListener('scroll', e => {
      const scrollTop = e.target.scrollTop
      const width = window.innerWidth
      if (width > 768) {
        this.innerShow = true
        return true
      }
      this.innerShow = scrollTop > 40;
    })
  },
  created() {},
  watch: {
    search(n, o) {
      this.search = n ? n.toLocaleUpperCase() : ''
    },
    location_id: {
      deep: true,
      handler(n, o) {
        if (n && n.id) {
          if (n.id === 'all') {
            this.monthly_depreciation_assumption = this.locations[1].monthly_depreciation_assumption
            this.monthly_mileage_assumption = this.locations[1].monthly_mileage_assumption
          } else {
            this.monthly_depreciation_assumption = n.monthly_depreciation_assumption
            this.monthly_mileage_assumption = n.monthly_mileage_assumption
          }
        }
      }
    }
  },
  methods: {
    summerByKey(key) {
      return this.future
        .reduce((acc, cur) => {
          return acc + cur[key]
        }, 0)
        .toLocaleString('en-US', {
          style: 'currency',
          currency: 'USD'
        })
    },
    shiftRight() {
      this.rightInterval = setInterval(() => {
        this.$refs.tablev2.scrollLeft += 50
      }, 50)
    },
    shiftRightEnd() {
      clearInterval(this.rightInterval)
    },
    shiftLeft() {
      this.leftInterval = setInterval(() => {
        this.$refs.tablev2.scrollLeft -= 50
      }, 50)
    },
    shiftLeftEnd() {
      clearInterval(this.leftInterval)
    },
    selectAll() {
      this.saved_locations = this.locations
        .filter(l => l.id !== 'all')
        .map(location => {
          return {
            name: location.name,
            location: location.id,
            monthly_depreciation_assumption: this.monthly_depreciation_assumption,
            monthly_mileage_assumption: this.monthly_mileage_assumption,
            code: location.code
          }
        })
    },
    directReq() {
      if (this.location_id.id === 'all') this.selectAll()
      else
        this.saved_locations.push({
          name: this.location_id.name,
          location: this.location_id.id,
          monthly_depreciation_assumption: this.monthly_depreciation_assumption,
          monthly_mileage_assumption: this.monthly_mileage_assumption,
          code: this.location_id.code
        })
      this.getReport()
      this.onReset()
    },
    sortTable(row) {
      this.sort.name === row ? this.sort.count++ : ''
      this.sort.name = row
      const order = this.sort.count % 2 == 0 ? 'asc' : 'desc'
      const deep = [...this.future]
      const sorted = deep.sort(this.sortVehicles(row, order))
      this.future = sorted
    },
    sortVehicles(key, order) {
      return function innerSort(a, b) {
        if (!a.hasOwnProperty(key) || !b.hasOwnProperty(key)) {
          return 0
        }
        var varA, varB

        if (typeof a[key] === 'string') {
          varA = a[key] ? a[key].toUpperCase() : ''
        } else if (typeof a[key] === 'object') {
          varA = a[key] && a[key].name ? a[key].name.toUpperCase() : ''
        } else varA = a[key]

        if (typeof b[key] === 'string') {
          varB = b[key] ? b[key].toUpperCase() : ''
        } else if (typeof b[key] === 'object') {
          varB = b[key] && b[key].name ? b[key].name.toUpperCase() : ''
        } else varB = b[key]

        let comparison = 0
        if (varA > varB) {
          comparison = 1
        } else if (varA < varB) {
          comparison = -1
        }
        return order === 'desc' ? comparison * -1 : comparison
      }
    },
    clear() {
      this.onReset()
      this.saved_locations = []
    },
    async detail(item) {
      try {
        this.$q.loading.show({
          sanitize: true
        })
        const { id, monthly_depreciation_assumption, monthly_mileage_assumption } = item
        const body = {
          monthly_depreciation_assumption,
          monthly_mileage_assumption
        }
        const { data } = await axios.post(`vehicle-analysis/future-value-by-yearly/${id}`, body)
        this.show = true
        this.carDetails = item
        this.$store.dispatch('future/SET_VEHICLE', data.data)
      } catch (error) {
      } finally {
        this.$q.loading.hide()
      }
    },
    del(index) {
      this.saved_locations.splice(index, 1)
    },
    onSubmit() {
      if (this.location_id.id === 'all') this.selectAll()
      else
        this.saved_locations.push({
          name: this.location_id.name,
          location: this.location_id.id,
          monthly_depreciation_assumption: this.monthly_depreciation_assumption,
          monthly_mileage_assumption: this.monthly_mileage_assumption,
          code: this.location_id.code
        })
      this.onReset()
    },
    async getLocations() {
      try {
        const { data } = await axios.get('locations')
        this.locations = data.data.length > 0 ? [{ name: 'Select All', id: 'all' }, ...data.data] : []
      } catch (error) {}
    },
    locationChecker(val) {
      if (val === null) return 'Please choose locations'
    },
    async nameGenerator() {
      let name = `fms_future_value_`
      var currentdate = new Date()
      var datetime =
        currentdate.getDate() +
        '_' +
        (currentdate.getMonth() + 1) +
        '_' +
        currentdate.getFullYear() +
        '_' +
        currentdate.getHours() +
        ':' +
        currentdate.getMinutes() +
        ':' +
        currentdate.getSeconds()
      name += datetime
      return name
    },
    async exportExcel() {
      try {
        this.$q.loading.show({
          sanitize: true
        })
        const body = {
          months: parseInt(this.month),
          locations: this.saved_locations.map(loc => ({
            location: loc.location,
            monthly_depreciation_assumption: loc.monthly_depreciation_assumption,
            monthly_mileage_assumption: loc.monthly_mileage_assumption
          })),
          statuses: defaultStatusValues
        }
        // params: this.params,
        const { data } = await axios.post('vehicle-analysis/export-future-values', body, {
          responseType: 'blob'
        })

        const url = window.URL.createObjectURL(new Blob([data]))
        const link = document.createElement('a')
        link.href = url
        const name = await this.nameGenerator()
        link.setAttribute('download', `${name}.xlsx`)
        document.body.appendChild(link)
        link.click()
      } catch (error) {
      } finally {
        this.$q.loading.hide()
      }
    },
    async getReport() {
      try {
        this.future = []
        this.loading = true
        const body = {
          months: parseInt(this.month),
          locations: this.saved_locations.map(loc => ({
            location: loc.location,
            monthly_depreciation_assumption: loc.monthly_depreciation_assumption,
            monthly_mileage_assumption: loc.monthly_mileage_assumption
          })),
          statuses: defaultStatusValues
        }
        // { params:this.params }
        const { data } = await axios.post('vehicle-analysis/future-values', body)
        this.future =
          data?.data.map((item, index) => ({
            ...item,
            index: index + 1
          })) || []
      } catch (error) {
      } finally {
        this.loading = false
      }
    },
    onReset() {
      this.location_id = null
      this.monthly_depreciation_assumption = null
      this.monthly_mileage_assumption = null
      this.$refs.form.resetValidation()
    }
  }
}
</script>

<style lang="scss" scoped>
.main-table {
  margin-bottom: 50px;
}

.calculate-rows {
  display: flex;
  flex-flow: column nowrap;
  gap: 2px;
  margin-bottom: 180px;
  margin-top: 10px;
}

.black-box {
  border-radius: 5px;
  cursor: pointer;
  padding: 15px;
  display: flex;
  flex-flow: column nowrap;
  flex: 1;
  width: 100%;
  align-items: center;
  justify-content: center;
  background: #000;
  .black-box-title {
    color: #fff;
    font-size: 13px;
    font-weight: 300;
    text-align: center;
  }
  .black-box-value {
    color: #fff;
    text-align: center;
    font-size: 20px;
    font-weight: 700;
  }
}
.custom-item-icon-4 {
  z-index: 999 !important;
  position: fixed !important;
  top: 60% !important;
}
.hide {
  display: none;
}
.future-header {
  font-size: 18px;
  font-weight: bold;
  padding: 10px 13px;
  text-align: left;
  align-items: center;
  display: flex;
  border-bottom: 1px solid #ccc;
}
.future-content {
  padding: 10px;
}

.container-of-future {
  display: flex;
  flex: 1;
  height: 100vh;
  flex-flow: row nowrap;
  .future-req {
    transform: translateZ(0);
    position: fixed;
    overflow-y: auto;
    height: 100%;
    width: 250px;
    z-index: 15;
  }
  .result-of-future {
    margin: 0px 10px;
    margin-left: 270px;
    width: calc(100% - 250px);
  }
}

@media only screen and (max-width: 1023px) {
  .custom-item-icon-4 {
    z-index: 999 !important;
    position: fixed !important;
    top: 88% !important;
  }
  .container-of-future {
    display: flex;
    flex: 1;
    flex-flow: column nowrap;
    .future-req {
      transform: translateZ(0);
      position: relative;
      width: 100%;
    }
    .result-of-future {
      margin: 10px 0px;
      width: 100%;
    }
  }
}
.flip-list-move {
  transition: transform 0.5s;
}
.no-move {
  transition: transform 0s;
}
.flip-list-move {
  transition: transform 500ms;
}
</style>
